/* Mega Menu Tabs — hover/click interaction for tabbed mega menus */
(function() {
  function initMegaMenuTabs() {
    document.querySelectorAll('.mega-menu-tabs').forEach(function(container) {
      var navItems = container.querySelectorAll('.mega-menu-tabs__nav-item');
      var panels = container.querySelectorAll('.mega-menu-tabs__panel');

      function activateTab(tabIndex) {
        /* tabIndex of -1 means direct-link item — don't change panels */
        if (tabIndex === -1) return;

        navItems.forEach(function(item) {
          var idx = parseInt(item.getAttribute('data-tab-index'), 10);
          item.classList.toggle('is-active', idx === tabIndex);
        });
        panels.forEach(function(panel) {
          var idx = parseInt(panel.getAttribute('data-panel-index'), 10);
          panel.classList.toggle('is-active', idx === tabIndex);
        });
      }

      navItems.forEach(function(item) {
        var idx = parseInt(item.getAttribute('data-tab-index'), 10);
        item.addEventListener('mouseenter', function() {
          activateTab(idx);
        });
        item.addEventListener('focus', function() {
          activateTab(idx);
        });
      });

      /* Activate first panel that exists */
      if (panels.length > 0) {
        var firstIdx = parseInt(panels[0].getAttribute('data-panel-index'), 10);
        activateTab(firstIdx);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuTabs);
  } else {
    initMegaMenuTabs();
  }

  /* Re-init on Shopify editor events */
  document.addEventListener('shopify:section:load', initMegaMenuTabs);
})();
